import ContainerForgotPWEmail from "./Components/ContainerForgotPWEmail";
import ContainerForgotPWCode from "./Components/ContainerForgotPWCode";
import ContainerForgotPWReset from "./Components/ContainerForgotPWReset";
import { useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ForgotPW() {
  const [step, setStep] = useState("email");
  const navigate = useNavigate();
  const [recoveryData, setRecoveryData] = useState({
    email: "",
    code: "",
  });

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative flex justify-center items-center min-h-dvh bg-zi-bg1-light dark:bg-zi-bg1-dark">
      {step === "email" && (
        <ContainerForgotPWEmail
          text="فراموشی رمز عبور"
          onContinue={(email) => {
            setRecoveryData((previous) => ({ ...previous, email }));
            setStep("code");
          }}
          onBack={() => navigate("/signin")}
        />
      )}
      {step === "code" && (
        <ContainerForgotPWCode
          email={recoveryData.email}
          onBack={() => setStep("email")}
          onContinue={(code) => {
            setRecoveryData((previous) => ({ ...previous, code }));
            setStep("reset");
          }}
        />
      )}
      {step === "reset" && (
        <ContainerForgotPWReset
          text="تنظیم مجدد رمز عبور"
          onBack={() => setStep("code")}
        />
      )}
    </div>
  );
}
